(() => {
  const KEY = 'seifenlaedeli_wissen_hautkompass_shown_v1';
  const COOKIE = 'seifenlaedeli_wissen_hautkompass_shown_v1';
  const readCookie = (name) => document.cookie.split(';').some((part) => part.trim() === `${name}=1`);
  const cookieSettings = `; Path=/; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;
  // A session cookie coordinates tabs; sessionStorage mirrors it across articles.
  // Probe only capabilities, never the shown marker, before actually showing.
  const allowed = () => {
    try {
      if (readCookie(COOKIE)) return false;
      try { if (window.sessionStorage.getItem(KEY) === '1') return false; } catch (_) { /* cookie fallback */ }
      const probe = `${COOKIE}_probe`;
      document.cookie = `${probe}=1${cookieSettings}`;
      const works = readCookie(probe);
      document.cookie = `${probe}=; Max-Age=0${cookieSettings}`;
      return works; // Fail closed when no cross-tab session marker can be stored.
    } catch (_) { return false; }
  };
  const initialize = (dialog) => {
    if (dialog.dataset.wissenInitialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.wissenInitialized = 'true';
    if (!allowed()) return;
    let shown = false;
    let frame = null;
    let previousFocus = null;
    const restoreFocus = () => {
      if (previousFocus?.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
    };
    const dismiss = () => { if (dialog.open) dialog.close(); };
    dialog.querySelectorAll('[data-wissen-dismiss]').forEach((button) => button.addEventListener('click', dismiss));
    dialog.querySelector('[data-wissen-navigate]')?.addEventListener('click', dismiss);
    dialog.addEventListener('close', restoreFocus);
    // Native Escape/cancel and focus containment remain intact.
    const otherModalOpen = () => [...document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], .modal.is-active, .modal.active')].some((element) => {
      if (element === dialog || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
    const stopWatching = () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('visibilitychange', schedule);
      observer.disconnect();
    };
    const check = () => {
      frame = null;
      if (shown || document.visibilityState !== 'visible' || !dialog.isConnected) return;
      const scroller = document.scrollingElement || document.documentElement;
      const travel = scroller.scrollHeight - window.innerHeight;
      // Total page travel, not article height, viewport bottom, or a time delay.
      if (travel <= 0 || scroller.scrollTop / travel < 0.6 || otherModalOpen()) return;
      if (!allowed()) { stopWatching(); return; }
      previousFocus = document.activeElement;
      try { dialog.showModal(); } catch (_) { return; }
      if (!dialog.open) return;
      shown = true;
      try {
        document.cookie = `${COOKIE}=1${cookieSettings}`;
        if (!readCookie(COOKIE)) { dismiss(); stopWatching(); return; }
        try { window.sessionStorage.setItem(KEY, '1'); } catch (_) { /* session cookie remains authoritative */ }
      } catch (_) { dismiss(); }
      stopWatching();
    };
    function schedule() {
      if (shown || frame !== null || document.visibilityState !== 'visible') return;
      frame = window.requestAnimationFrame(check);
    }
    // Retry at the same reading position after a competing modal closes.
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'aria-modal', 'class', 'style'] });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    schedule();
  };
  document.querySelectorAll('[data-wissen-invitation]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-wissen-invitation]').forEach(initialize));
})();
